// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'https://bajaj.carot.com',
  // apiV1Url: 'https://bajaj.carot.com/v1',
  // apiV2Url: 'https://bajaj.carot.com/v2',
  // apiUrl: 'https://qa3.carot.com',
  // apiV1Url: 'https://qa3.carot.com/v1',
  // apiV2Url: 'https://qa3.carot.com/v2'
  // apiUrl: 'https://bajajstaging.carot.com/'
  // apiUrl: 'https://qa3.carot.com',
  // apiV1Url: 'https://qa3.carot.com/v1',
  // apiV2Url: 'https://qa3.carot.com/v2',

  apiUrl: 'https://www.carot.com',
  apiV1Url: 'https://www.carot.com/v1',
  apiV2Url: 'https://www.carot.com/v2',
  carotUrl: 'https://fleet.carot.com/',
  //  apiUrl: 'https://qa8.carot.com',
  // apiV1Url: 'https://qa8.carot.com/v1',
  // apiV2Url: 'https://qa8.carot.com/v2',



};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
